import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { logoutInvestorSession } from '../../utils/investorBotApi';

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #000000;
  border-bottom: 1px solid #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 999;

  @media (min-width: 768px) {
    max-width: 414px;
    margin: 0 auto;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const Logo = styled.img`
  height: 24px;
  width: auto;
`;

const Title = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UserBadge = styled.div`
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #333333;
  font-size: 12px;
  color: #ffffff;
  font-family: 'Plus Jakarta Sans', sans-serif;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LogoutButton = styled.button`
  padding: 8px 12px;
  border-radius: 10px;
  background: #111111;
  border: 1px solid #333333;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #444444;
    background: #1a1a1a;
  }
`;

const InvestorPWAHeader: React.FC = () => {
  const navigate = useNavigate();
  const investorName = localStorage.getItem('investorName') || 'Investor';

  const handleLogout = () => {
    const token = localStorage.getItem('investorSessionToken');
    if (token) {
      logoutInvestorSession(token);
    }
    localStorage.removeItem('investorName');
    localStorage.removeItem('investorId');
    localStorage.removeItem('investorSessionToken');
    localStorage.removeItem('investorWalletPublicKey');
    navigate('/investor-pwa');
  };

  return (
    <HeaderContainer>
      <LogoSection onClick={() => navigate('/investor-pwa/dashboard')}>
        <Logo src="/landing-assets/mavrk_word_logo.png" alt="Mavrk" />
        <Title>Investor</Title>
      </LogoSection>
      <Actions>
        <UserBadge title={investorName}>{investorName}</UserBadge>
        <LogoutButton onClick={handleLogout}>Log out</LogoutButton>
      </Actions>
    </HeaderContainer>
  );
};

export default InvestorPWAHeader;
